// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMinimize2 as RawLucideMinimize2 } from "lucide-react";
export const LucideMinimize2 = /* @__PURE__ */ createIcon(RawLucideMinimize2, "LucideMinimize2", 2);
